// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nOIx-","label":"styles_label__15bpC"};